import { formatPrice } from "../../order/utils/formatPrice.js";
export const getNextDispatchPrice = (dispatch, isBookClub) => {
    if (!isBookClub) {
        return undefined;
    }
    const price = dispatch?.price;
    if (typeof price !== "number" || Number.isNaN(price)) {
        return undefined;
    }
    return formatPrice(price);
};
